import { ApiEndpoint } from "../enums/ApiEndpoint";

export const fetchXeroStatus = async (): Promise<any> => {
  return fetch(ApiEndpoint.XERO_STATUS).then(res => res.json());
};
